/**
 * Convert unit descriptorName to image filename
 * Example: "Descriptor_Unit_2K11_KRUG_SOV" -> "2K11_KRUG_SOV.png"
 */
export function getUnitImageFilename(descriptorName: string): string {
  // Remove "Descriptor_Unit_" prefix if present
  const withoutPrefix = descriptorName.replace(/^Descriptor_Unit_/, "");
  return `${withoutPrefix}.png`;
}

/**
 * Get unit image path from descriptor name
 * Example: "Descriptor_Unit_2K11_KRUG_SOV" -> "/images/units/2K11_KRUG_SOV.png"
 */
export function getUnitImagePath(descriptorName: string): string {
  const filename = getUnitImageFilename(descriptorName);
  return `/images/units/${filename}`;
}

